import axios from "axios";
import mem from "mem";

import Http from "./Http";
import { StorageService } from "./StorageService";
import { initService } from "@/base/hooks/useService";
import { localstorageKeys } from "@const/store";

/**
 * @returns {Promise<AxiosResponse<T>>}
 */
export const sendRefreshToken = async () => {
  const API = `${Http.api.common}/${Http.versions.v1}/sessions`;

  /**
   * @type {StorageService}
   */
  const storageService = initService(StorageService);
  const { refreshToken } = storageService.get(localstorageKeys.session, {});

  const response = await axios.put(API, { refreshToken });

  const newSession = response?.data?.data;

  storageService.set(localstorageKeys.session, newSession);

  // Return the token directly to avoid needing another .get() from storageService
  return newSession.accessToken;
};

const maxAge = 2000;

export const memoizedSendRefreshToken = mem(sendRefreshToken, {
  maxAge,
});
